import { render, staticRenderFns } from "./MANUAL_phone.vue?vue&type=template&id=012046a8&scoped=true"
import script from "./MANUAL_phone.vue?vue&type=script&lang=js"
export * from "./MANUAL_phone.vue?vue&type=script&lang=js"
import style0 from "./MANUAL_phone.vue?vue&type=style&index=0&id=012046a8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "012046a8",
  null
  
)

export default component.exports